import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // 导入中文语言包
import 'leaflet/dist/leaflet.css'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import './assets/common.css'
import '@/assets/css/map.css'
import axios from 'axios'
import { encryptPassword,md5 } from '@/utils/password'
import BridgeEventBus from '@/utils/BridgeEventBus' // 导入事件总线
import VideoUrlManager from '@/utils/videoUrlManager' // 导入视频URL管理器

// 导入数据可视化组件
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts'

// 导入应用配置
import appConfig from '@/config/app-config'

// 导入SignalRManager
import signalRManager from '@/utils/signalr-manager'

// 导入iframe/token认证工具
import { isInIframe } from '@/utils/token-auth'

// 解决leaflet默认图标路径问题
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// 设置 axios 的默认配置
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'http://localhost:8080/api'

// 将事件总线挂载到Vue原型
Vue.prototype.$bus = BridgeEventBus

// 将SignalRManager挂载到Vue原型，方便组件访问
Vue.prototype.$signalR = signalRManager

// 将应用配置挂载到Vue原型，方便组件访问
Vue.prototype.$appConfig = appConfig

// 使用Element UI并指定中文语言包
Vue.use(ElementUI, { locale, size: 'medium' })

// 使用dataV组件
Vue.use(dataV)

// 将echarts挂载到Vue原型
Vue.prototype.$echarts = echarts

// 添加全局安全保护
// 保存原始的$emit方法
const originalEmit = Vue.prototype.$emit;

// 重写$emit方法，添加安全检查
Vue.prototype.$emit = function(event) {
  // 防止undefined或null事件名
  if (event === undefined || event === null) {
    console.error('Vue $emit错误: 事件名称不能为undefined或null');
    // 打印堆栈跟踪以便定位错误来源
    console.error('错误调用堆栈:', new Error().stack);
    return this;
  }
  
  // 过滤高频率事件，不输出日志
  const highFrequencyEvents = [
    'mouse-move', 
    'update:zoom', 
    'update:center',
    'update:bounds',
    'input',
    'hover',
    'mouseover',
    'cell-mouse-enter',
    'cell-mouse-leave',
    'click',
    'ready',
    'updatePopper',
    'mouseleave'
  ];
  
  // // 仅对非高频事件记录日志
  // if (!highFrequencyEvents.includes(event)) {
  //   // console.debug(`Vue组件触发事件: ${event}`);
  // }
  
  // 调用原始方法
  return originalEmit.apply(this, arguments);
};

// 添加全局错误处理
Vue.config.errorHandler = function(err, vm, info) {
  console.error('Vue全局错误:', err);
  console.error('错误组件:', vm.$options.name || vm.$options._componentTag || '未命名组件');
  console.error('错误信息:', info);
  
  // 尝试获取更多上下文信息
  if (vm.$options._componentTag === 'bridge-map' || 
      vm.$options.name === 'BridgeMap' || 
      (vm.$parent && (vm.$parent.$options.name === 'BridgeManagement'))) {
    console.error('桥梁地图组件发生错误，可能的相关状态:', {
      'marker': vm.$attrs.marker || '未知',
      'area': vm.savedAreas || '未知',
      'drawingMode': vm.drawingMode || '未知'
    });
  }
};

Vue.config.warnHandler = function(msg, vm, trace) {
  console.warn('Vue警告:', msg);
  console.warn('警告组件:', vm.$options.name || vm.$options._componentTag || '未命名组件');
  console.warn('组件调用栈:', trace);
};

Vue.config.productionTip = false

// 初始化SignalR管理器
signalRManager.init({
  autoReconnect: true,
  maxReconnectAttempts: 999999,
  reconnectInterval: 3
});

// 检测iframe环境并输出日志
if (isInIframe()) {
  console.log('[App] 检测到当前页面运行在iframe中');
  // 在iframe模式下，可以添加特殊的样式类
  document.documentElement.classList.add('in-iframe');
}

// VideoUrlManager已在模块内部初始化，这里不需要额外初始化代码

// 为调试方便，暴露到全局
if (process.env.NODE_ENV === 'development') {
  window.$signalR = signalRManager;
  window.signalRManager = signalRManager;
  window.$appConfig = appConfig;
  window.encryptPassword = encryptPassword;
  window.md5 = md5;
  window.VideoUrlManager = VideoUrlManager; // 暴露VideoUrlManager到全局
  window.BridgeEventBus = BridgeEventBus; // 暴露BridgeEventBus到全局
  // 输出应用配置信息
  console.log('应用配置信息:', appConfig.getFullConfig());
  console.log('SignalR服务端地址:', appConfig.signalR.serverUrl);
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 